import styled from 'styled-components';

import Text from '../../../units/Text/Text';

const FormTitle = styled(Text).attrs({
  size: '20px',
  font: 'caption',
  bold: true
})`
  margin-bottom: 25px;
`;

export { FormTitle };



// WEBPACK FOOTER //
// ./src/components/containers/Forms/FormUnits/FormUnits.js